module.exports = __webpack_public_path__ + "static/media/work-05-small.81c17e6e.jpg";